import { EListingActions } from '../../../constants/actionTypes/listing';
import { DEFAULT_META } from '../../../constants/meta';
import { TReduxActions } from '../../../types/redux';
import { IAgenciesListing } from '../../../types/redux/agencies';

export const defaultState = {
  items: [],
  page: 1,
  meta: DEFAULT_META,
};

export function agenciesListingReducer(state: IAgenciesListing = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EListingActions.SET_AGENCIES_ITEMS:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      };

    case EListingActions.SET_AGENCIES_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };

    default:
      return state;
  }
}
